import React from "react";
import { Link } from "react-router-dom";

function UserHeader() {
  return (
    <div>
      <div className="page-wrapper">
        <header className="header header-2 header-intro-clearance">
          <div className="header-top">
            <div className="container">
              <div className="header-left">
                <p>Special collection already available.</p>
                <Link to="/#">&nbsp;Read more ...</Link>
              </div>
              {/* End .header-left */}
              <div className="header-right">
                <ul className="top-menu">
                  <li>
                    <Link to="/#">Links</Link>
                    <ul>
                      <li>
                        <div className="header-dropdown">
                          <Link to="/#">USD</Link>
                          <div className="header-menu">
                            <ul>
                              <li>
                                <Link to="/#">Eur</Link>
                              </li>
                              <li>
                                <Link to="/#">Usd</Link>
                              </li>
                            </ul>
                          </div>
                          {/* End .header-menu */}
                        </div>
                      </li>
                      <li>
                        <div className="header-dropdown">
                          <Link to="/#">English</Link>
                          <div className="header-menu">
                            <ul>
                              <li>
                                <Link to="/#">English</Link>
                              </li>
                              <li>
                                <Link to="/#">French</Link>
                              </li>
                              <li>
                                <Link to="/#">Spanish</Link>
                              </li>
                            </ul>
                          </div>
                          {/* End .header-menu */}
                        </div>
                      </li>
                      <li>
                        <Link to="/login" data-toggle="modal">
                          Sign in / Sign up
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
                {/* End .top-menu */}
              </div>
              {/* End .header-right */}
            </div>
            {/* End .container */}
          </div>
          {/* End .header-top */}
          <div className="header-middle">
            <div className="container">
              <div className="header-left">
                <button className="mobile-menu-toggler">
                  <span className="sr-only">Toggle mobile menu</span>
                  <i className="icon-bars" />
                </button>
                <Link to="/" className="logo" title="HR">
                  <img
                    src="https://static.vecteezy.com/system/resources/thumbnails/004/206/323/small/ss-logo-monogram-emblem-style-with-crown-shape-design-template-free-vector.jpg"
                    alt="SS Logo"
                    title="SS"
                    width={105}
                    height={25}
                  />
                </Link>
              </div>
              {/* End .header-left */}
              <div className="header-center">
                <div className="header-search header-search-extended header-search-visible header-search-no-radius d-none d-lg-block">
                  <Link to="/#" className="search-toggle" role="button">
                    <i className="icon-search" />
                  </Link>
                  <form action="#" method="get">
                    <div className="header-search-wrapper search-wrapper-wide">
                      <label htmlFor="q" className="sr-only">
                        Search
                      </label>
                      <input
                        type="search"
                        className="form-control"
                        name="q"
                        id="q"
                        placeholder="Search product ..."
                        required
                      />
                      <button className="btn btn-primary" type="submit">
                        <i className="icon-search" />
                      </button>
                    </div>
                    {/* End .header-search-wrapper */}
                  </form>
                </div>
                {/* End .header-search */}
              </div>
              <div className="header-right">
                <div className="account">
                  <Link to="/login" title="My account">
                    <div className="icon">
                      <i className="icon-user" />
                    </div>
                    <p>Account</p>
                  </Link>
                </div>
                {/* End .compare-dropdown */}
                <div className="wishlist">
                  <Link to="/wishlist" title="Wishlist">
                    <div className="icon">
                      <i className="icon-heart-o" />
                      <span className="wishlist-count badge">3</span>
                    </div>
                    <p>Wishlist</p>
                  </Link>
                </div>
                {/* End .compare-dropdown */}
                <div className="dropdown cart-dropdown">
                  <a
                    href="#"
                    className="dropdown-toggle"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-display="static"
                  >
                    <div className="icon">
                      <i className="icon-shopping-cart" />
                      <span className="cart-count">2</span>
                    </div>
                    <p>Cart</p>
                  </a>
                  <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-cart-products">
                      <div className="product">
                        <div className="product-cart-details">
                          <h4 className="product-title">
                            <Link to="/product">
                              Beige knitted elastic runner shoes
                            </Link>
                          </h4>
                          <span className="cart-product-info">
                            <span className="cart-product-qty">1</span>x $84.00
                          </span>
                        </div>
                        {/* End .product-cart-details */}
                        <figure className="product-image-container">
                          <Link to="/product.html" className="product-image">
                            <img
                              src="asset/images/products/cart/product-1.jpg"
                              alt="product"
                            />
                          </Link>
                        </figure>
                        <a
                          href="#"
                          className="btn-remove"
                          title="Remove Product"
                        >
                          <i className="icon-close" />
                        </a>
                      </div>
                      {/* End .product */}
                      <div className="product">
                        <div className="product-cart-details">
                          <h4 className="product-title">
                            <Link to="/product.html">
                              Blue utility pinafore denim dress
                            </Link>
                          </h4>
                          <span className="cart-product-info">
                            <span className="cart-product-qty">1</span>x $76.00
                          </span>
                        </div>
                        {/* End .product-cart-details */}
                        <figure className="product-image-container">
                          <Link to="/product.html" className="product-image">
                            <img
                              src="asset/images/products/cart/product-2.jpg"
                              alt="product"
                            />
                          </Link>
                        </figure>
                        <a
                          href="#"
                          className="btn-remove"
                          title="Remove Product"
                        >
                          <i className="icon-close" />
                        </a>
                      </div>
                      {/* End .product */}
                    </div>
                    {/* End .cart-product */}
                    <div className="dropdown-cart-total">
                      <span>Total</span>
                      <span className="cart-total-price">$160.00</span>
                    </div>
                    {/* End .dropdown-cart-total */}
                    <div className="dropdown-cart-action">
                      <Link to="/cart" className="btn btn-primary">
                        View Cart
                      </Link>
                      <Link
                        to="/checkout"
                        className="btn btn-outline-primary-2"
                      >
                        <span>Checkout</span>
                        <i className="icon-long-arrow-right" />
                      </Link>
                    </div>
                    {/* End .dropdown-cart-total */}
                  </div>
                  {/* End .dropdown-menu */}
                </div>
                {/* End .cart-dropdown */}
              </div>
              {/* End .header-right */}
            </div>
            {/* End .container */}
          </div>
          {/* End .header-middle */}
          <div className="header-bottom sticky-header">
            <div className="container">
              <div className="header-left">
                <div className="dropdown category-dropdown">
                  <a
                    href="#"
                    className="dropdown-toggle"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-display="static"
                    title="Browse Categories"
                  >
                    Browse Categories
                  </a>
                  <div className="dropdown-menu">
                    <nav className="side-nav">
                      <ul className="menu-vertical sf-arrows">
                        <li className="item-lead">
                          <Link to="/#">Daily offers</Link>
                        </li>
                        <li className="item-lead">
                          <Link to="/#">Gift Ideas</Link>
                        </li>
                        <li>
                          <Link to="/#">Beds</Link>
                        </li>
                        <li>
                          <Link to="/#">Lighting</Link>
                        </li>
                        <li>
                          <Link to="/#">Sofas &amp; Sleeper sofas</Link>
                        </li>
                        <li>
                          <Link to="/#">Storage</Link>
                        </li>
                        <li>
                          <Link to="/#">Armchairs &amp; Chaises</Link>
                        </li>
                        <li>
                          <Link to="/#">Decoration </Link>
                        </li>
                        <li>
                          <Link to="/#">Kitchen Cabinets</Link>
                        </li>
                        <li>
                          <Link to="/#">Coffee &amp; Tables</Link>
                        </li>
                        <li>
                          <Link to="/#">Outdoor Furniture </Link>
                        </li>
                      </ul>
                      {/* End .menu-vertical */}
                    </nav>
                    {/* End .side-nav */}
                  </div>
                  {/* End .dropdown-menu */}
                </div>
                {/* End .category-dropdown */}
              </div>
              {/* End .header-left */}
              <div className="header-center">
                <nav className="main-nav">
                  <ul className="menu sf-arrows">
                    <li className="megamenu-container active">
                      <Link to="/newindex" className="sf-with-ul">
                        Home
                      </Link>
                      <div className="megamenu demo">
                        <div className="menu-col">
                          <div className="menu-title">Choose your demo</div>
                          {/* End .menu-title */}
                          <div className="demo-list">
                            <div className="demo-item">
                              <Link to="/index1">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/1.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  01 - furniture store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index2">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/2.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  02 - furniture store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index3">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/3.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  03 - electronic store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index4">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/4.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  04 - electronic store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index5">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/5.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  05 - fashion store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index6">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/6.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  06 - fashion store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index7">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/7.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  07 - fashion store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index8">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/8.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  08 - fashion store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index9">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/9.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  09 - fashion store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index10">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/10.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  10 - shoes store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index11">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/11.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  11 - furniture simple store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index12">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/12.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  12 - fashion simple store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index13">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/13.jpg)",
                                  }}
                                />
                                <span className="demo-title">13 - market</span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index14">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/14.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  14 - market fullwidth
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index15">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/15.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  15 - lookbook 1
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index16">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/16.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  16 - lookbook 2
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index17">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/17.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  17 - fashion store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index18">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/18.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  18 - fashion store (with sidebar)
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index19">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/19.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  19 - games store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index20">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/20.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  20 - book store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index21">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/21.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  21 - sport store
                                </span>
                              </Link>
                            </div>
                            {/* End .demo-item */}
                            <div className="demo-item">
                              <Link to="/index22">
                                <span
                                  className="demo-bg"
                                  style={{
                                    backgroundImage:
                                      "url(asset/images/menu/demos/22.jpg)",
                                  }}
                                />
                                <span className="demo-title">
                                  22 - tools store
                                </span>
                              </Link>
                            </div>
                           
                          </div>
                          {/* End .demo-list */}
                          {/* <div className="megamenu-action text-center">
                            <a
                              href="#"
                              className="btn btn-outline-primary-2 view-all-demos"
                            >
                              <span>View All Demos</span>
                              <i className="icon-long-arrow-right" />
                            </a>
                          </div> */}
                          {/* End .text-center */}
                        </div>
                        {/* End .menu-col */}
                      </div>
                      {/* End .megamenu */}
                    </li>
                  
                    <li>
                      <Link to="/product" className="sf-with-ul">
                        Product
                      </Link>
                      <div className="megamenu megamenu-sm">
                        <div className="row no-gutters">
                          <div className="col-md-6">
                            <div className="menu-col">
                              <div className="menu-title">Product Details</div>
                              {/* End .menu-title */}
                              <ul>
                                <li>
                                  <Link to="/product">Default</Link>
                                </li>
                                <li>
                                  <Link to="/productcentred">Centered</Link>
                                </li>
                                <li>
                                  <Link to="/productextended">
                                    <span>
                                      Extended Info
                                      <span className="tip tip-new">New</span>
                                    </span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/productextendedgallery">Gallery</Link>
                                </li>
                                <li>
                                  <Link to="/productsticky">Sticky Info</Link>
                                </li>
                                <li>
                                  <Link to="/productsidebar">
                                    Boxed With Sidebar
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/productfullwidth">
                                    Full Width
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/productmansonry">
                                    Masonry Sticky Info
                                  </Link>
                                </li>

                                <li>
                          <Link to="/ladies" className="sf-with-ul">
                            Items
                          </Link>
                          <ul>
                            <li>
                              <Link to="/ladies">Ladies</Link>
                            </li>
                            <li>
                              <Link to="/boys">Boys</Link>
                            </li>
                          </ul>
                        </li>
                              </ul>
                            </div>
                            {/* End .menu-col */}
                          </div>
                          {/* End .col-md-6 */}
                          <div className="col-md-6">
                            <div className="banner banner-overlay">
                              <Link to="/category.html">
                                <img
                                  src="asset/images/menu/banner-2.jpg"
                                  alt="Banner"
                                />
                                <div className="banner-content banner-content-bottom">
                                  <div className="banner-title text-white">
                                    New Trends
                                    <br />
                                    <span>
                                      <strong>spring 2019</strong>
                                    </span>
                                  </div>
                                  {/* End .banner-title */}
                                </div>
                                {/* End .banner-content */}
                              </Link>
                            </div>
                            {/* End .banner */}
                          </div>
                          {/* End .col-md-6 */}
                        </div>
                        {/* End .row */}
                      </div>
                      {/* End .megamenu megamenu-sm */}
                    </li>
                    <li>
                      <Link to="/#" className="sf-with-ul">
                        Pages
                      </Link>
                      <ul>
                        <li>
                          <Link to="/userabout" className="sf-with-ul">
                            About
                          </Link>
                          <ul>
                            <li>
                              <Link to="/userabout">About 01</Link>
                            </li>
                            <li>
                              <Link to="/userabout2">About 02</Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link to="/usercontact" className="sf-with-ul">
                            Contact
                          </Link>
                         
                        </li>
                        <li>
                          <Link to="/login">Login</Link>
                        </li>
                        
                      </ul>
                      
                    </li>
                  
                   
                  </ul>
                  {/* End .menu */}
                </nav>
                {/* End .main-nav */}
              </div>
              {/* End .header-center */}
              <div className="header-right">
                <i className="la la-lightbulb-o" />
                <p>
                  Clearance
                  <span className="highlight">&nbsp;Up to 30% Off</span>
                </p>
              </div>
            </div>
            {/* End .container */}
          </div>
          {/* End .header-bottom */}
        </header>
        {/* End .header */}
        
     
       
       
      </div>
    </div>
  );
}

export default UserHeader;
